import { render, staticRenderFns } from "./VersionModalTip.vue?vue&type=template&id=40f0e010&scoped=true"
import script from "./VersionModalTip.vue?vue&type=script&lang=js"
export * from "./VersionModalTip.vue?vue&type=script&lang=js"
import style0 from "./VersionModalTip.vue?vue&type=style&index=0&id=40f0e010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0e010",
  null
  
)

export default component.exports